import type { ReactNode } from 'react'
import { IconButton } from './ui/Button'
import { Icon } from './ui/icons'

interface TopBarProps {
  title: string
  subtitle?: string
  leftElement?: ReactNode
  rightElement?: ReactNode
  onMenuClick?: () => void
}

export default function TopBar({
  title,
  subtitle,
  leftElement,
  rightElement,
  onMenuClick,
}: TopBarProps) {
  return (
    <div className="sticky top-0 z-30 flex h-14 items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 sm:px-6">
      <div className="flex min-w-0 items-center gap-2">
        {onMenuClick && (
          <IconButton
            label="Open navigation menu"
            onClick={onMenuClick}
            className="lg:hidden"
          >
            <Icon name="menu" className="h-5 w-5" />
          </IconButton>
        )}
        {leftElement}
        <div className="min-w-0">
          <h1 className="truncate text-base font-semibold text-slate-900">{title}</h1>
          {subtitle && <p className="truncate text-xs text-slate-500">{subtitle}</p>}
        </div>
      </div>

      {rightElement && (
        <div className="flex shrink-0 items-center gap-2">
          {rightElement}
        </div>
      )}
    </div>
  )
}
